import { RootState } from 'reducer';
import { useSelector } from 'react-redux';

const useHasMoreFeed = () => {
  return useSelector((state: RootState) => {
    const pagination = state.feed.pagination;
    if (!pagination) return false;

    const { totalPage, currentPage } = pagination;

    if (totalPage === 0 || totalPage === currentPage) return false;

    return true;
  });
};

const useFeedCurrentPage = () => {
  return useSelector((state: RootState) => {
    const pagination = state.feed.pagination;
    if (!pagination) return 0;
    return pagination.currentPage;
  });
};

const useFeedApiStatus = () => {
  return useSelector((state: RootState) => {
    const apiStatus = state.feed.api;
    return apiStatus;
  });
};

export { useHasMoreFeed, useFeedCurrentPage, useFeedApiStatus };
